/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyViewResponse {
    getFixupPrototypeFunction() { return PolicyViewResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyViewResponse>): PolicyViewResponse {
        let obj = Object.assign(new PolicyViewResponse(), model);
        PolicyViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyViewResponse>): PolicyViewResponse {
        if (!model) return null;
        return PolicyViewResponse.newInstance(<PolicyViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyViewResponse) {
        if (!obj) return;

        models.PolicyViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyViewResponse): boolean {
        Object.setPrototypeOf(obj, PolicyViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The unique identifier created for each policy.
     */
    policy_id: string;

    /**
     * The name of the policy without space or special character
     */
    policy_name: string;

    /**
     * A brief explanation of the policy.
     */
    description: string;

    /**
     * Indicates whether the policy is active or inactive.
     */
    status: string;

    /**
     * The category will be either service or resource.
     */
    category: string;

    /**
     * Engine type of policy
     */
    engine_type: string;

    /**
     * Displays the service associated with the policy for example, AWS, AzureRM, Openstack., etc
     */
    services: Array<string>;

    /**
     * The scope of the policy: Global Scope - All users will have access to view and execute CoreStack Marketplace policies; will not have access to update/delete them, Account scope - All users under that account will have access to view and execute Only Account admins can update/delete the policies, Tenant Scope - Users with access to the specific tenant will have access to policies who can describe or execute policies. Tenant admins can only update/delete. Private Scope - User who created will only have access
     */
    scope: models.AccountScope;

    /**
     * Content type of policy (Git or File)
     */
    content_type: string;

    /**
     * The policy content.
     */
    content: string;

    /**
     * Git project URL when the content type is git.
     */
    git_content_url: string;

    /**
     * Username of Git repo if repo is authenticated
     */
    git_content_username: string;

    /**
     * Root path of the policy in git repo.
     */
    git_content_path: string;

    /**
     * Policies are classified based on the basis of the activity they perform, for example provisioning, Account Management, Utilization, etc. This value is displayed in this field.
     */
    classification: string;

    /**
     * Sub classification of policy
     */
    sub_classification: string;

    /**
     * Severity of policy
     */
    severity: models.PolicySeverityRisk;

    /**
     * Flag to identify system policy
     */
    is_system_policy: string;

    /**
     * Unique URI for policy
     */
    uri: string;

}
